<div class="block-content-round">
  <div class="ion-grid-padding">
    <p class="ion-margin-top-0">
      <strong>{{ account().company.name }}</strong>
    </p>
    <p class="fs-sm ion-color-medium">
      {{ account().company.postalCode }} {{ account().company.city }} ({{
        'states.' + account().company.countryCode + account().company.stateCode | translate
      }}),
      {{ 'countries.' + account().company.countryCode | translate }}
    </p>
  </div>
</div>
